import { DefaultKavkomIntegration } from 'common/Globals'
import produce from 'immer'
import { AUTH, PROFILE } from 'store/actions/types'

const initialState = {
    data: {},
    didLoaded: false,
    didsErrorMessage: null,
    did: null,
    globalCodecPrefs: [],
    integration: null,
    getProfileFinished: false
}

export default function profileReducer(state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case AUTH.SIGNIN_USER_SUCCESS:
            return produce(state, (draft) => {
                if (payload) {
                    draft.data = payload
                }
            })

        case AUTH.SIGNOUT_USER_SUCCESS:
            return produce(state, (draft) => {
                draft.data = {}
                draft.didLoaded = false
                draft.did = null
            })

        case PROFILE.GET_PROFILE_SUCCESS:
            return produce(state, (draft) => {
                if (payload) {
                    draft.data = payload
                    draft.did = payload?.did
                    delete draft.data.did
                    draft.didLoaded = true
                    draft.globalCodecPrefs = payload?.codecs?.outbound_codec_prefs || []
                    draft.integration = payload?.installed_integration
                        ? {
                              ...DefaultKavkomIntegration,
                              ...payload.installed_integration
                          }
                        : DefaultKavkomIntegration
                    draft.getProfileFinished = true
                }
            })

        case PROFILE.SET_DID:
            return produce(state, (draft) => {
                if (payload) {
                    draft.did = payload
                }
            })

        case PROFILE.SET_DID_FAIL:
            return produce(state, (draft) => {
                draft.didsErrorMessage = payload.message
                if (payload.prevValue) {
                    draft.did = payload.prevValue
                }
            })

        case PROFILE.CLEAR_ALERT:
            return produce(state, (draft) => {
                draft.didsErrorMessage = null
            })

        default:
            return state
    }
}
